export enum ZIndexLayers {
  Modal = 2000,
  ChatBox = 3000,
  Alert = 4000,
}
